import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Card from '../../base/Card/Card.js';
import Carousel from '../../base/Carousel/Carousel.js';
import FundManager from '../FundManager/FundManager.js';

import {
	IFundManagersCarouselConfiguration,
	IFundManagersCarouselProps,
	IFundManagersCarouselState,
} from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import {
	FUND_MANAGERS_CAROUSEL_CATEGORY_KEY,
	FUND_MANAGERS_CAROUSEL_COMPONENT_KEY,
} from './FundManagersCarousel.meta.js';

export class FundManagersCarousel extends ComponentBase<
	IFundManagersCarouselProps,
	IFundManagersCarouselState,
	IFundManagersCarouselConfiguration
> {
	categoryKey = FUND_MANAGERS_CAROUSEL_CATEGORY_KEY;
	componentKey = FUND_MANAGERS_CAROUSEL_COMPONENT_KEY;

	constructor(props: IFundManagersCarouselProps) {
		super(props);
	}
	render() {
		const { className, managers, cardProps, carouselProps, fundManagerProps } = this.props;
		return (
			<Wrapper className={className}>
				<Card {...(cardProps || {})}>
					<Carousel {...(carouselProps || {})}>
						{(managers || []).map((manager, index) => {
							return (
								<FundManager
									key={`fund_manager_${index}`}
									{...(fundManagerProps || {})}
									value={manager}
								/>
							);
						})}
					</Carousel>
				</Card>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(FundManagersCarousel),
	FUND_MANAGERS_CAROUSEL_CATEGORY_KEY,
	FUND_MANAGERS_CAROUSEL_COMPONENT_KEY,
);
